export const phoneNumber = '9177686139';
export const phoneNumberDisplay = '917.768.6139';
export const addressLine1 = '175 Greenwich St. (Floor 38)';
export const addressLine2 = 'New York, NY 10014';
export const addressLine3 = 'United States';
export const email = 'info@vancery.com';
export const googleMapsLink = 'https://goo.gl/maps/koDtDDsCQBweX5sM8';